import React from "react";
import { Link } from "react-router-dom";

import { Button } from "reactstrap";

const Page401 = () => (
  <div className="text-center">
    <h1 className="display-1 font-weight-bold">401</h1>

    <p className="h1">Unauthorized</p>

    <p className="h2 font-weight-normal mt-3 mb-4">
      You are not authorized to access this page, ensure you are logged into the correct user for
      the content you are trying to reach
    </p>

    <Link to="/dashboard/campaigns">
      <Button color="primary" size="lg">
        Return to dashboard
      </Button>
    </Link>
  </div>
);

export default Page401;
